export default __webpack_public_path__ + "8b74842c2cf8732f43acdb08a5f08710.svg";